// Generated by tools/gen-backend-hooks.ts — do not edit by hand.
// One hook per endpoint in backend/dashboardPage/.

import { makeBackendHook } from './_client'

export type { BackendQuery, TriggerOptions } from './_client'

/** POST /api/rpc/dashboardPage/getAnalytics */
export const useGetAnalytics = makeBackendHook('dashboardPage', 'getAnalytics')

/** POST /api/rpc/dashboardPage/getCachedForecast */
export const useGetCachedForecast = makeBackendHook('dashboardPage', 'getCachedForecast')

/** POST /api/rpc/dashboardPage/getForecastAccuracy */
export const useGetForecastAccuracy = makeBackendHook('dashboardPage', 'getForecastAccuracy')

/** POST /api/rpc/dashboardPage/getOrderPredictions */
export const useGetOrderPredictions = makeBackendHook('dashboardPage', 'getOrderPredictions')

/** POST /api/rpc/dashboardPage/getProfitability */
export const useGetProfitability = makeBackendHook('dashboardPage', 'getProfitability')

/** POST /api/rpc/dashboardPage/getWeeklyDigest */
export const useGetWeeklyDigest = makeBackendHook('dashboardPage', 'getWeeklyDigest')

/** POST /api/rpc/dashboardPage/sendWeeklyDigest */
export const useSendWeeklyDigest = makeBackendHook('dashboardPage', 'sendWeeklyDigest')
